import { TemplateRef, ViewContainerRef } from '@angular/core';
import { Overlay } from '@angular/cdk/overlay';
import { TemplatePortal } from '@angular/cdk/portal';
var OverlayService = /** @class */ (function () {
    function OverlayService(overlay) {
        this.overlay = overlay;
    }
    OverlayService.prototype.createOverlay = function (config) {
        return this.overlay.create(config);
    };
    OverlayService.prototype.attachTemplatePortal = function (overlayRef, templateRef, vcRef) {
        var templatePortal = new TemplatePortal(templateRef, vcRef);
        overlayRef.attach(templatePortal);
    };
    OverlayService.prototype.positionGloballyCenter = function () {
        return this.overlay.position()
            .global()
            .centerHorizontally()
            .centerVertically();
    };
    return OverlayService;
}());
export { OverlayService };
